import { Component, Vue } from "vue-property-decorator";

// Helpers
import { isMissingDocumentInformation } from "@/plugins/user_helper";
import { Getter } from "vuex-class";
@Component
export default class DashboardSidebar extends Vue {
  @Getter getUser;

  get isShowingMissingDocumentNotification() {
    return isMissingDocumentInformation(this.getUser);
  }

  navigate(routeName: string) {
    if (!this.isCurrentRouteName(routeName)) this.$router.push({ name: routeName });
    document
      .getElementById("SubscriptionDashboard")
      .scroll({ top: 0, left: 0, behavior: "smooth" });
  }

  isCurrentRouteName(routeName: string) {
    return this.$route.name === routeName;
  }
}
